import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

interface IProps {
    label: string;
    score: number | null | undefined;
    description: string;
}

export default function ConnectivityScoreBadge({ label, score, description }: IProps) {
    if (score == null) {
        return null;
    }

    return (
        <Tooltip title={`${description} DfT scores range from 0 to 100; a higher score indicates better connectivity.`} arrow>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'help' }}>
                <Typography variant="body2">{label}</Typography>
                <Box sx={{ minWidth: 42, px: 1, py: 0.25, border: '1px solid #7ecad4', borderRadius: 1, textAlign: 'center', bgcolor: 'white' }}>
                    <Typography variant="body2" fontWeight={600}>{score}</Typography>
                </Box>
            </Box>
        </Tooltip>
    );
}
